import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { select, Store } from '@ngrx/store';
import * as adminReducer from '@modules/super-admin/reducers';
import { MatPaginator} from '@angular/material/paginator';
import { MatDialog } from '@angular/material';
import { EditAdminDialogComponent } from '@modules/super-admin/components/edit-admin-dialog/edit-admin-dialog.component';
import { AdminApiService } from '@modules/super-admin/services/admin-api.service';
import { ConfirmDialogComponent } from '@modules/shared/components/confirm-dialog/confirm-dialog.component';
import { MessengerService } from '@modules/messenger/messenger.service';
import _ from 'lodash';
import { ISalesAgent } from '@root/interfaces/salesAgent.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'edex-sales-agent',
  templateUrl: './sales-agent.component.html',
  styleUrls: ['./sales-agent.component.scss']
})
export class SalesAgentComponent implements OnInit {

  displayedColumns: string[] = ['contactName', 'email', 'phoneNumberCall', 'companyName', 'body','totalEarning','commission', 'actions'];
  dataSource = new MatTableDataSource<ISalesAgent>([]);

  search = '';
  debouncedSearch;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private store: Store<adminReducer.State>,
    private adminApi: AdminApiService,
    private msgr: MessengerService,
    public dialog: MatDialog,
    private router:Router
  ) {
    this.debouncedSearch = _.debounce(this.getSalesAgent.bind(this), 500);
  }

  ngOnInit() {
    this.getSalesAgent();
  }

  getSalesAgent() {
    this.adminApi.getSalesAgent({search: this.search,isDeleted: false}).subscribe((merchants:any) => {
      console.log('merchants',merchants);
      
      this.dataSource = new MatTableDataSource<ISalesAgent>(merchants);
      this.dataSource.paginator = this.paginator;
    });
  }

  openCreateAgentDialog() {
    const dialogRef = this.dialog.open(EditAdminDialogComponent, { data: {} });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getSalesAgent();
      }
    });

  }

  navigateMerchant(data) {
    console.log('wihjrfburgfu',data.SAreferenceNumber);
    this.adminApi.commissionPercent = data.commissionPercent
    this.router.navigate([`admin/sales-agent/saMerchant/${data.SAreferenceNumber}`]);
  }

  ngOnDestroy() {
  }

  editAdmin(event: Event, admin: ISalesAgent) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(EditAdminDialogComponent, {
      data: {
        merchant: admin,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getSalesAgent();
      }
    });
  }

  deleteAdmin(event: Event, admin: ISalesAgent) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        text: 'Are you sure to remove this Sales Agent?'
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.adminApi.deleteAdmin(admin._id).subscribe(
          (res) => {
            this.getSalesAgent();
          },
          (err) => {
            this.msgr.error(err.message);
          }
        );
      }
    });
  }
}
